import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <img src="/seal-oddlytrue-red-wax.png" alt="OddlyTrue" className="w-14 h-14 object-contain seal-stamp" />
          <span className="font-display text-3xl font-extrabold text-ink">
            Oddly<span className="text-gold">True</span>
          </span>
        </div>

        <div className="rounded-3xl border border-slate-200 bg-white shadow-sm p-8">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="w-4 h-4 text-gold" />
            <h1 className="font-mono text-sm uppercase tracking-widest text-ink-muted">Admin Command Center</h1>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block font-mono text-xs uppercase tracking-wider text-ink-muted mb-2">Email</label>
              <input
                data-testid="admin-login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-ink focus:outline-none focus:border-gold focus:bg-white transition-colors"
                placeholder="admin@oddlytrue.co"
              />
            </div>
            <div>
              <label className="block font-mono text-xs uppercase tracking-wider text-ink-muted mb-2">Password</label>
              <input
                data-testid="admin-login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-ink focus:outline-none focus:border-gold focus:bg-white transition-colors"
                placeholder="••••••••"
              />
            </div>
            {error && <p data-testid="admin-login-error" className="text-sm text-red-600 font-mono">{error}</p>}
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-xl bg-ink text-white font-mono uppercase tracking-wider text-sm hover:bg-gold hover:text-ink disabled:opacity-60 transition-colors"
            >
              {loading ? "Verifying..." : "Enter"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
